import { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Facebook OAuth Context.
 * Provides the Facebook authentication state and related functions.
 *
 * @constant
 * @type {React.Context<Object|null>}
 */
export const FacebookOAuthContext = createContext(null);

/**
 * Prop types for the Provider component of FacebookOAuthContext.
 * Ensures that the provider receives valid children.
 *
 * @property {React.ReactNode} children - The content to be rendered within the provider.
 */
FacebookOAuthContext.Provider.propTypes = {
	children: PropTypes.node
};
